angular.module('portal.i18n').constant('AvailableLocales', [
    'en_GB',
    'en_US',
    'es_ES',
    'de_DE',
    'pt_PT',
]);